module.exports = __webpack_public_path__ + "img/image-trash.795e4db4.svg";